import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { IDatasourceActions } from '../../../../ts/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../../../ts/ServerApi/types/IWorkbookActions';
import { runExtractRefresh } from '../../../actions/spaces/RunExtractRefreshAction';
import { selectSpaceInfoItem } from '../../../selectors/SpaceInfoSelectors';
import { AppState } from '../../../state/AppState';
import { hasExtractRefreshPermission, hasRunNowPermission } from '../../../utils/MixedContentHelpers';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const RunExtractRefreshEntityAction: IEntityAction<IExtractTaskInfo, IWorkbookActions | IDatasourceActions> = {
  name: EntityActionNames.TasksRunNow,
  translateName: Messages.runNow_action,
  isVisible: () => true,
  isClickable: isClickable,
  createReduxAction: runExtractRefresh
};

function isClickable(
  availableActions: IWorkbookActions | IDatasourceActions,
  tasks: IExtractTaskInfo[],
  state: AppState
): boolean {
  const spaceItem = selectSpaceInfoItem(state);
  return hasExtractRefreshPermission(state, spaceItem, availableActions) && hasRunNowPermission(state);
}
